module.exports = __webpack_public_path__ + "img/1-4.705d162a.png";